import { Injectable } from '@angular/core';

import { AuthService } from '@usheru-hff/authentication/domain';
import { Link } from '@usheru-hff/shared/domain';
import { AuthenticationModalService } from '@usheru-hff/shared/utils-authentication';
import { CommunityElementsService, CollectionRoutesEnum as Routes } from '@usheru-hff/shared/utils-community';

@Injectable({
  providedIn: 'root'
})
export class MyActivityService {
  private onActivityClick = () => {
    if (!this.authService.isLoggedIn()) {
      this.uiAuthService.presentLoginOptions();
      return false;
    }
    return true;
  };

  private savedLink = {
    name: 'saved',
    url: Routes.USER_ACTIVITY_SAVED,
    position: 1,
    visibility: 3,
    order: 1,
    command: this.onActivityClick
  };
  private seenLink = {
    name: 'seen',
    url: Routes.USER_ACTIVITY_SEEN,
    position: 1,
    visibility: 3,
    order: 1,
    command: this.onActivityClick
  };
  private rated = {
    name: 'rated',
    url: Routes.USER_ACTIVITY_RATED,
    position: 1,
    visibility: 3,
    order: 1,
    command: this.onActivityClick
  };
  private lists = {
    name: 'my lists',
    url: Routes.USER_ACTIVITY_MY_LISTS,
    position: 1,
    visibility: 3,
    order: 1,
    command: this.onActivityClick
  };
  private followers = {
    name: 'followers',
    url: Routes.USER_ACTIVITY_FOLLOWERS,
    position: 1,
    visibility: 3,
    order: 1,
    command: this.onActivityClick
  };
  private following = {
    name: 'following',
    url: Routes.USER_ACTIVITY_FOLLOWING,
    position: 1,
    visibility: 3,
    order: 1,
    command: this.onActivityClick
  };
  private MY_ACTIVITY_LINK_GROUP_ID = 777;

  constructor(
    private authService: AuthService,
    private communityFeaturesService: CommunityElementsService,
    private uiAuthService: AuthenticationModalService
  ) {}

  getMyActivityLinkGroup(isUserLoggedIn: boolean): Link {
    const availableLinks = [];
    if (isUserLoggedIn) {
      if (this.communityFeaturesService.isFeatureEnabled('wishlist')) availableLinks.push(this.savedLink);
      if (this.communityFeaturesService.isFeatureEnabled('watched')) availableLinks.push(this.seenLink);
      if (this.communityFeaturesService.isFeatureEnabled('rating')) availableLinks.push(this.rated);
      if (this.communityFeaturesService.isFeatureEnabled('lists')) availableLinks.push(this.lists);
      if (this.communityFeaturesService.isFeatureEnabled('followers')) {
        availableLinks.push(this.followers);
        availableLinks.push(this.following);
      }
    }
    return {
      children: availableLinks,
      name: 'My Activity',
      order: 1,
      id: this.MY_ACTIVITY_LINK_GROUP_ID,
      position: 1,
      url: '',
      visibility: 3,
      command: this.onActivityClick
    };
  }
}
